<template>
    <div @click="$emit('click')" class="zhaw-result-panel" v-bind:class="{ selected: isSelected }">
        {{ courseType }}
        {{ courseName }}
        <div v-if="recommendationScore >= 0">
            <span class="zhaw-result-panel-recommendation">Empfehlung:</span>
            <Score :score="recommendationScore" />
        </div>
    </div>
</template>

<script>
    import Score from "./Score";

    export default {
        name: "ResultOverviewPanel",
        components: {Score},
        props: {
            courseName: String,
            courseType: String,
            recommendationScore: Number,
            isSelected: Boolean
        }
    }
</script>

<style scoped>
    .zhaw-result-panel {
        background-color: #f8f9fa;
        border: 1px solid #00000020;
        border-radius: 0.25rem;
        box-shadow: 1px 1px #00000020;
        padding: 10px;
        margin: 5px;
        cursor: pointer;
    }

    .zhaw-result-panel:hover {
        background-color: rgba(18, 102, 172, 0.05);
    }

    .zhaw-result-panel:active {
        box-shadow: inset 1px 1px #00000020;
    }

    .zhaw-result-panel.selected {
        background-color: rgba(18, 102, 172, 0.10);
        box-shadow: inset 0 0 5px #00000020;
    }

    .zhaw-result-panel-recommendation {
        font-size: 14px;
        padding-right: 5px;
    }
</style>